export default {
	global: {
		selectItem: 'Select an item…',
		retry: 'Retry',
		ok: 'Ok',
		back: 'Back',
		developmentMode: 'Development mode activated.',
		errors: {
			connectivity: {
				401: 'Unauthorized.',
				408: 'No internet connection, please try again.',
				500: 'Unknown error, please try again.',
				unknown: 'Unknown error, please try again.',
			},
		},
		offlineWarning: {
			title: 'No internet connection',
			description:
				"You cannot perform this action because you're offline. Make sure you are connected to WiFi or a mobile network and try again.",
		},
		login: {
			action: 'Login',
		},
		logout: {
			action: 'Log out',
			modal: {
				title: 'Log out',
				description: 'Are you sure you wish to log out?',
				cancel: 'Cancel',
				confirm: 'Log out',
			},
		},
	},
	screens: {
		about: {
			identification: 'Identification',
			appVersion: 'App version',
			apiVersion: 'Api version',
			development: {
				copyToClipboard: 'Copied to clipboard',
				accessToken: 'Access token',
				startUpTime: 'Start-up time',
				tapToCopy: 'Tap to copy',
			},
		},
		colleagues: {
			all: 'All colleagues',
			inZone: 'Colleagues in zone',
			noColleaguesTitle: 'No colleagues yet',
			noColleaguesDescription:
				'None of your colleagues has made a reservation for the specified reservation details.',
		},
		profile: {
			about: 'About this app',
			calendarConnect: 'Connect calendar',
			calendarConnectSuccessModal: {
				confirm: 'OK',
				description: 'Your calendar has been connected successfully!',
				title: 'Connect calendar',
			},
			calendarDisconnect: 'Disconnect calendar',
			calendarDisconnectModal: {
				cancel: 'Cancel',
				confirm: 'Disconnect',
				description: 'Are you sure you wish to disconnect your calendar?',
				title: 'Disconnect calendar',
			},
			calendarDisconnectSuccessModal: {
				confirm: 'OK',
				description: 'Your calendar has been disconnected successfully!',
				title: 'Disconnect calendar',
			},
			reservationPreferences: 'Reservation preferences',
			screenTitle: 'My profile',
		},
		reservationPreferences: {
			screenTitle: 'Reservation preferences',
			save: 'Save',
			complete: {
				title: 'Your preferences have been stored successfully!',
			},
			timeslot: {
				label: 'Timeslot',
				from: 'From',
				to: 'To',
				placeholder: 'Choose a start time',
				placeholder_2: 'Choose an end time',
			},
			office: {
				error: 'No locations found',
				label: 'Location',
				placeholder: 'Choose a location',
			},
			floor: {
				error: 'No floors found',
				label: 'Floor',
				placeholder: 'Choose a floor',
			},
			zone: {
				error: 'No zones found',
				label: 'Zone',
				placeholder: 'Choose a zone',
			},
			desk: {
				error: 'No desks found',
				label: 'Desk',
				placeholder: 'Choose a desk',
			},
		},
		reservations: {
			checkIn: 'Check in',
			checkOut: 'Check out',
			checkOutModal: {
				cancel: 'Cancel',
				confirm: 'Check out',
				description: 'Are you sure you wish to check out from this reservation?',
				title: 'Check out from reservation',
			},
			delete: 'Delete reservation',
			deleteModal: {
				cancel: 'Cancel',
				confirm: 'Delete',
				description: 'Are you sure you wish to delete this reservation?',
				title: 'Delete reservation',
			},
			edit: 'Edit reservation',
			noReservationsTitle: 'No reservations yet',
			noReservationsDescription:
				'You have not yet made reservations. All reservations you make will appear on this screen',
			scanQr: 'Scan ticket',
			share: {
				label: 'Share reservation',
				title: 'Share reservation',
				message:
					'I have created a reservation on {{date}}: office "{{office}}", floor "{{floor}}", zone "{{zone}}" and desk "{{desk}}".',
			},
			today: 'Today',
			tomorrow: 'Tomorrow',
			title: 'My upcoming reservations',
			viewColleagues: 'Show colleagues present',
			viewFloorplan: 'View floorplan',
			floorplan: 'Floorplan',
			office: 'Office',
			floor: 'Floor',
			zone: 'Zone',
			desk: 'Desk',
			limitAlert: {
				title: 'Reservation limit reached',
				description:
					'You have reached your limit for future reservations. Please remove existing reservations first.',
			},
		},
		reservation: {
			submit: {
				label: 'Show {{count}} desks',
			},
			dateSelection: {
				label: 'Date',
				placeholder: 'Choose date',
			},
			timeslotSelection: {
				label: 'Timeslot',
				from: 'From',
				to: 'To',
				placeholder: 'Choose a start time',
				placeholder_2: 'Choose an end time',
				list: {
					fullDay: 'Full-day',
					morning: 'Morning',
					afternoon: 'Afternoon',
					other: 'Other timeslot',
				},
			},
			officeSelection: {
				error: 'No space available',
				label: 'Location',
				multipleSelected: '{{count}} selected',
				placeholder: 'Choose a location',
			},
			floorSelection: {
				error: 'No space available',
				label: 'Floor',
				multipleSelected: '{{count}} selected',
				placeholder: 'Choose a floor',
			},
			zoneSelection: {
				error: 'No space available',
				label: 'Zone',
				multipleSelected: '{{count}} selected',
				placeholder: 'Choose a zone',
			},
			deskSelection: {
				error: 'No space available',
				label: 'Desk',
				placeholder: 'Choose a desk',
			},
		},
		reservationFilter: {
			applyFilter: 'Apply filter ({{deskCount}} desks)',
		},
		reservationResults: {
			screenTitle: 'Reserve workplace',
			submit: 'Reserve workplace',
		},
		reservationComplete: {
			title: 'Your chosen reservation has been confirmed!',
		},
		scanner: {
			screenTitle: 'Checkin Scanner',
			errors: {
				default: 'An unknown error occured.',
				400: 'Scanned QR code is not valid.',
				404: 'No reservation found.',
			},
		},
		version: {
			reinstall: {
				title: 'A brand new App!',
				caption: 'We have a new App. ✨ Switch to the new CIAO app now and discover the new design.',
				button: 'Download now',
			},
			update: {
				title: 'New version',
				caption:
					'Your current CIAO app version is not supported anymore, update the app to continue using it! Thank you.',
				button: 'Update now',
			},
		},
	},
};
